(function() {
  'use strict';

  console.log('=== ETIKETTEN TOOL LOADED ===');

  // Define all functions first

  // Change quantity function
  function changeQty(index, delta) {
    var input = document.getElementById('qty-' + index);
    if (!input) {
      console.error('Quantity input not found for index:', index);
      return;
    }
    var currentVal = parseInt(input.value) || 10;
    var newVal = currentVal + delta;
    if (newVal < 1) newVal = 1;
    if (newVal > 100) newVal = 100;
    input.value = newVal;
    console.log('Quantity changed from', currentVal, 'to', newVal, 'for product', index);
    updateSelection();
  }

  // Get selected products
  function getSelectedProducts() {
    var selected = [];
    var items = document.querySelectorAll('.product-item');

    items.forEach(function(item) {
      var i = item.dataset.index;
      var chk = document.getElementById('chk-' + i);

      if (chk && chk.checked) {
        var qtyInput = document.getElementById('qty-' + i);
        var qty = qtyInput ? parseInt(qtyInput.value) || 10 : 10;

        selected.push({
          title: item.dataset.title || '',
          beschreibung: item.dataset.beschreibung || '',
          zutaten: item.dataset.zutaten || '',
          ziehdauerMin: item.dataset.ziehdauerMin || '',
          ziehdauerMax: item.dataset.ziehdauerMax || '',
          temperaturMin: item.dataset.temperaturMin || '',
          temperaturMax: item.dataset.temperaturMax || '',
          bio: item.dataset.bio === 'true',
          qty: qty
        });
      }
    });

    console.log('Selected products:', selected.length);
    return selected;
  }

  // Update selection display
  function updateSelection() {
    try {
      var selected = getSelectedProducts();
      var totalLabels = selected.reduce(function(sum, p) { return sum + p.qty; }, 0);
      var totalPages = Math.ceil(totalLabels / 10);
      var info = document.getElementById('selected-info');
      var btnPrint = document.getElementById('btn-print');

      if (!info || !btnPrint) {
        console.error('Selection info or print button not found');
        return;
      }

      if (selected.length === 0) {
        info.textContent = 'Keine Produkte ausgewählt';
        btnPrint.disabled = true;
        btnPrint.style.opacity = '0.5';
        btnPrint.style.cursor = 'not-allowed';
      } else {
        info.innerHTML = '<strong>' + selected.length + '</strong> Produkt' + (selected.length > 1 ? 'e' : '') +
          ' · <strong>' + totalLabels + '</strong> Etiketten' +
          ' · <strong>' + totalPages + '</strong> Seite' + (totalPages > 1 ? 'n' : '');
        btnPrint.disabled = false;
        btnPrint.style.opacity = '1';
        btnPrint.style.cursor = 'pointer';
      }

      console.log('Selection updated:', selected.length, 'products,', totalLabels, 'labels');
    } catch (error) {
      console.error('Error updating selection:', error);
    }
  }

  // Generate and print labels - moved up before usage
  function generateAndPrint() {
    try {
      var selected = getSelectedProducts();
      if (selected.length === 0) {
        console.log('No products selected for printing');
        return;
      }

      console.log('Generating labels for', selected.length, 'products...');
      var allLabels = [];

      selected.forEach(function(product) {
        for (var i = 0; i < product.qty; i++) {
          var bioHtml = '';
          if (product.bio) {
            if (window.BIO_ICON_URL) {
              bioHtml = '<img src="' + window.BIO_ICON_URL + '" class="icon_image" />';
            } else {
              bioHtml = '<svg class="icon_image" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">' +
                '<circle cx="50" cy="50" r="45" fill="none" stroke="#000" stroke-width="3"/>' +
                '<text x="50" y="58" text-anchor="middle" font-size="28" fill="#000">BIO</text></svg>';
            }
          }

          var ziehText = '';
          if (product.ziehdauerMin) {
            var zieh = product.ziehdauerMin;
            if (product.ziehdauerMax && parseInt(product.ziehdauerMax) > parseInt(product.ziehdauerMin)) {
              zieh += '–' + product.ziehdauerMax;
            }
            var temp = product.temperaturMin;
            if (product.temperaturMax && parseInt(product.temperaturMax) > parseInt(product.temperaturMin)) {
              temp += '–' + product.temperaturMax;
            }
            ziehText = '<p>' + zieh + '&nbsp;Min. bei ' + temp + '°C ziehen lassen.</p>';
          }

          allLabels.push(
            '<div class="etiketten_item">' +
              '<div class="content without_icons">' +
                '<div class="inner">' +
                  '<h1>' + product.title + '</h1>' +
                  (product.beschreibung ? '<p>' + product.beschreibung + '</p>' : '') +
                  (product.zutaten ? '<p>Zutaten: ' + product.zutaten + '</p>' : '') +
                  ziehText +
                '</div>' +
              '</div>' +
              '<div class="footer small">' +
                (product.bio ? '<div class="bio_icon_footer">' + bioHtml + '</div>' : '') +
                '<h3>Teeblatt</h3>' +
                '<p>Milchgasse 2, 5000 Aarau, www.teeblatt.ch</p>' +
              '</div>' +
            '</div>'
          );
        }
      });

      // Arrange into pages of 10
      var labelsHtml = '';
      for (var page = 0; page < Math.ceil(allLabels.length / 10); page++) {
        var pageLabels = allLabels.slice(page * 10, (page + 1) * 10);
        labelsHtml += '<div class="etiketten_container">';

        labelsHtml += '<div class="container_5_items">';
        for (var i = 0; i < Math.min(5, pageLabels.length); i++) {
          labelsHtml += pageLabels[i];
        }
        labelsHtml += '</div>';

        if (pageLabels.length > 5) {
          labelsHtml += '<div class="container_5_items flip">';
          for (var j = 5; j < pageLabels.length; j++) {
            labelsHtml += pageLabels[j];
          }
          labelsHtml += '</div>';
        }

        labelsHtml += '</div>';
      }

      // Open print window
      var printWindow = window.open('', '_blank');
      printWindow.document.write(
        '<!DOCTYPE html>' +
        '<html lang="de">' +
        '<head>' +
        '<meta charset="UTF-8">' +
        '<title>Etiketten drucken</title>' +
        '<style>' +
          '@font-face {' +
            'font-family: "MaisonNeue-Demi";' +
            'src: url("https://cdn.shopify.com/s/files/1/0981/7899/0457/files/MaisonNeue-Demi.woff2?v=1771508939") format("woff2"),' +
                 'url("https://cdn.shopify.com/s/files/1/0981/7899/0457/files/MaisonNeue-Demi.woff?v=1771508939") format("woff");' +
            'font-style: normal; font-weight: 400;' +
          '}' +
          '@font-face {' +
            'font-family: "MaisonNeue-Light";' +
            'src: url("https://cdn.shopify.com/s/files/1/0981/7899/0457/files/MaisonNeue-Light.woff2?v=1771508254") format("woff2"),' +
                 'url("https://cdn.shopify.com/s/files/1/0981/7899/0457/files/MaisonNeue-Light.woff?v=1771508876") format("woff");' +
            'font-style: normal; font-weight: 400;' +
          '}' +
          '@font-face {' +
            'font-family: "Sofa-Sans-Hand";' +
            'src: url("https://cdn.shopify.com/s/files/1/0981/7899/0457/files/Sofa-Sans-Hand.woff2?v=1771508255") format("woff2"),' +
                 'url("https://cdn.shopify.com/s/files/1/0981/7899/0457/files/Sofa-Sans-Hand.woff?v=1771508815") format("woff");' +
            'font-style: normal; font-weight: 400;' +
          '}' +
          '*, *:before, *:after { box-sizing: border-box; margin: 0; padding: 0; }' +
          'html, body { width: 297mm; height: 210mm; margin: 0; padding: 0; }' +
          'body {' +
            'font-size: 8.5pt; line-height: 11pt;' +
            'font-family: "MaisonNeue-Light", Arial, sans-serif;' +
            'font-weight: normal; color: #000; background: #fff;' +
            'text-rendering: optimizeLegibility;' +
            '-webkit-font-smoothing: antialiased;' +
          '}' +
          'h1, h2, h3, h4 {' +
            'font-family: "Sofa-Sans-Hand", Georgia, serif;' +
            'font-style: normal; font-variant: normal; font-weight: normal; color: #000;' +
          '}' +
          'h1 {' +
            'width: 100%; margin-left: auto; margin-right: auto;' +
            'font-size: 22pt; line-height: 25pt; margin-bottom: 6mm;' +
          '}' +
          'h3 {' +
            'font-family: "MaisonNeue-Demi", Arial, sans-serif;' +
            'font-size: 10pt; line-height: 13pt; margin-bottom: 2mm;' +
          '}' +
          '.small { font-size: 6pt; line-height: 7.5pt; }' +
          'b, strong { font-family: "MaisonNeue-Demi", Arial, sans-serif; font-weight: 400; }' +
          '.etiketten_container {' +
            'position: relative; margin-left: 6mm;' +
            'width: calc(297mm - 6mm); height: 210mm;' +
            'font-size: 8.5pt; line-height: 11pt;' +
            'font-family: "MaisonNeue-Light", Arial, sans-serif;' +
            '-webkit-page-break-after: always; page-break-after: always; break-after: always;' +
          '}' +
          '.etiketten_container::after { clear: both; content: ""; display: table; }' +
          '.container_5_items { position: static; float: left; width: 100%; height: 105mm; }' +
          '.container_5_items.flip {' +
            'transform: scale(-1, -1); transform-origin: center center; margin-left: -6mm;' +
          '}' +
          '.etiketten_item { position: relative; float: left; width: 57mm; height: 105mm; }' +
          '.etiketten_item .content {' +
            'position: absolute; top: 0; left: 0;' +
            'width: 57mm; height: 80mm;' +
            'padding-top: 12mm; text-align: center; overflow: hidden;' +
          '}' +
          '.etiketten_item .content.without_icons { height: 93mm; }' +
          '.etiketten_item .content h1 { hyphens: manual; padding-left: 1mm; padding-right: 1mm; }' +
          '.etiketten_item .content p { margin-bottom: 4mm; hyphens: manual; padding-left: 1mm; padding-right: 1mm; }' +
          '.etiketten_item .bio_icon_footer {' +
            'width: 100%; text-align: center; margin-bottom: 2mm;' +
          '}' +
          '.etiketten_item .bio_icon_footer .icon_image {' +
            'width: 10mm; height: 10mm; display: inline-block;' +
          '}' +
          '.etiketten_item .footer {' +
            'position: absolute; bottom: 0; left: 0;' +
            'width: 57mm; height: auto; min-height: 12mm; text-align: center; padding-bottom: 2mm;' +
          '}' +
          '@media print {' +
            '@page { size: 297mm 210mm landscape; margin: 0; }' +
            'body { margin: 0; padding: 0; }' +
          '}' +
        '</style>' +
        '</head>' +
        '<body>' +
        labelsHtml +
        '</body></html>'
      );
      printWindow.document.close();

      // Wait for fonts to load, then print
      setTimeout(function() {
        printWindow.focus();
        printWindow.print();
      }, 800);

    } catch (error) {
      console.error('Error generating labels:', error);
      alert('Fehler beim Erstellen der Etiketten. Bitte versuchen Sie es erneut.');
    }
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEtikettenTool);
  } else {
    initEtikettenTool();
  }

  function initEtikettenTool() {
    console.log('Etiketten tool initializing...');

    // Check if user has access
    var appContent = document.getElementById('app-content');
    if (!appContent) {
      console.log('No access to etiketten tool - user not authorized');
      return;
    }

    console.log('User has access, setting up tool...');

    // Initialize product count
    var items = document.querySelectorAll('.product-item');
    var countEl = document.getElementById('product-count');
    if (countEl && items.length > 0) {
      countEl.textContent = items.length + ' Tees';
      console.log('Found ' + items.length + ' products');
    }

    // Setup event delegation for better performance
    setupEventListeners();

    // Initial selection update
    updateSelection();

    console.log('Etiketten tool ready!');
  }

  function setupEventListeners() {
    // Use event delegation on the container
    var container = document.getElementById('product-items');
    if (!container) {
      console.error('Product container not found!');
      return;
    }

    // Handle all clicks in the product container
    container.addEventListener('click', function(e) {
      var target = e.target;

      // Handle checkbox clicks
      if (target.classList.contains('product-checkbox')) {
        console.log('Checkbox clicked:', target.dataset.index);
        updateSelection();
      }

      // Handle plus button clicks
      if (target.classList.contains('qty-plus')) {
        e.preventDefault();
        var index = target.dataset.index;
        console.log('Plus clicked for product:', index);
        changeQty(index, 1);
      }

      // Handle minus button clicks
      if (target.classList.contains('qty-minus')) {
        e.preventDefault();
        var index = target.dataset.index;
        console.log('Minus clicked for product:', index);
        changeQty(index, -1);
      }
    });

    // Handle quantity input changes
    container.addEventListener('change', function(e) {
      var target = e.target;
      if (target.classList.contains('qty-input')) {
        console.log('Quantity changed for product:', target.dataset.index);
        updateSelection();
      }
    });

    // Handle search
    var searchInput = document.getElementById('product-search');
    if (searchInput) {
      searchInput.addEventListener('input', function() {
        var query = this.value.toLowerCase().trim();
        var items = document.querySelectorAll('.product-item');
        var visibleCount = 0;
        items.forEach(function(item) {
          var title = (item.dataset.title || '').toLowerCase();
          if (!query || title.indexOf(query) !== -1) {
            item.classList.remove('hidden-by-search');
            visibleCount++;
          } else {
            item.classList.add('hidden-by-search');
          }
        });
        var countEl = document.getElementById('product-count');
        if (countEl) {
          countEl.textContent = visibleCount + ' Tees';
        }
      });
    }

    // Handle print button
    var btnPrint = document.getElementById('btn-print');
    if (btnPrint) {
      btnPrint.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Print button clicked');
        generateAndPrint();
      });
    }
  }

  // Change quantity function
  function changeQty(index, delta) {
    var input = document.getElementById('qty-' + index);
    if (!input) {
      console.error('Quantity input not found for index:', index);
      return;
    }
    var currentVal = parseInt(input.value) || 10;
    var newVal = currentVal + delta;
    if (newVal < 1) newVal = 1;
    if (newVal > 100) newVal = 100;
    input.value = newVal;
    console.log('Quantity changed from', currentVal, 'to', newVal, 'for product', index);
    updateSelection();
  }

  // Get selected products
  function getSelectedProducts() {
    var selected = [];
    var items = document.querySelectorAll('.product-item');

    items.forEach(function(item) {
      var i = item.dataset.index;
      var chk = document.getElementById('chk-' + i);

      if (chk && chk.checked) {
        var qtyInput = document.getElementById('qty-' + i);
        var qty = qtyInput ? parseInt(qtyInput.value) || 10 : 10;

        selected.push({
          title: item.dataset.title || '',
          beschreibung: item.dataset.beschreibung || '',
          zutaten: item.dataset.zutaten || '',
          ziehdauerMin: item.dataset.ziehdauerMin || '',
          ziehdauerMax: item.dataset.ziehdauerMax || '',
          temperaturMin: item.dataset.temperaturMin || '',
          temperaturMax: item.dataset.temperaturMax || '',
          bio: item.dataset.bio === 'true',
          qty: qty
        });
      }
    });

    console.log('Selected products:', selected.length);
    return selected;
  }

  // Update selection display
  function updateSelection() {
    try {
      var selected = getSelectedProducts();
      var totalLabels = selected.reduce(function(sum, p) { return sum + p.qty; }, 0);
      var totalPages = Math.ceil(totalLabels / 10);
      var info = document.getElementById('selected-info');
      var btnPrint = document.getElementById('btn-print');

      if (!info || !btnPrint) {
        console.error('Selection info or print button not found');
        return;
      }

      if (selected.length === 0) {
        info.textContent = 'Keine Produkte ausgewählt';
        btnPrint.disabled = true;
        btnPrint.style.opacity = '0.5';
        btnPrint.style.cursor = 'not-allowed';
      } else {
        info.innerHTML = '<strong>' + selected.length + '</strong> Produkt' + (selected.length > 1 ? 'e' : '') +
          ' · <strong>' + totalLabels + '</strong> Etiketten' +
          ' · <strong>' + totalPages + '</strong> Seite' + (totalPages > 1 ? 'n' : '');
        btnPrint.disabled = false;
        btnPrint.style.opacity = '1';
        btnPrint.style.cursor = 'pointer';
      }

      console.log('Selection updated:', selected.length, 'products,', totalLabels, 'labels');
    } catch (error) {
      console.error('Error updating selection:', error);
    }
  }

  // Generate and print labels
  function generateAndPrint() {
    try {
      var selected = getSelectedProducts();
      if (selected.length === 0) {
        console.log('No products selected for printing');
        return;
      }

      console.log('Generating labels for', selected.length, 'products...');
      var allLabels = [];

      selected.forEach(function(product) {
        for (var i = 0; i < product.qty; i++) {
          var bioHtml = '';
          if (product.bio) {
            if (window.BIO_ICON_URL) {
              bioHtml = '<img src="' + window.BIO_ICON_URL + '" class="icon_image" />';
            } else {
              bioHtml = '<svg class="icon_image" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">' +
                '<circle cx="50" cy="50" r="45" fill="none" stroke="#000" stroke-width="3"/>' +
                '<text x="50" y="58" text-anchor="middle" font-size="28" fill="#000">BIO</text></svg>';
            }
          }

          var ziehText = '';
          if (product.ziehdauerMin) {
            var zieh = product.ziehdauerMin;
            if (product.ziehdauerMax && parseInt(product.ziehdauerMax) > parseInt(product.ziehdauerMin)) {
              zieh += '–' + product.ziehdauerMax;
            }
            var temp = product.temperaturMin;
            if (product.temperaturMax && parseInt(product.temperaturMax) > parseInt(product.temperaturMin)) {
              temp += '–' + product.temperaturMax;
            }
            ziehText = '<p>' + zieh + '&nbsp;Min. bei ' + temp + '°C ziehen lassen.</p>';
          }

          allLabels.push(
            '<div class="etiketten_item">' +
              '<div class="content without_icons">' +
                '<div class="inner">' +
                  '<h1>' + product.title + '</h1>' +
                  (product.beschreibung ? '<p>' + product.beschreibung + '</p>' : '') +
                  (product.zutaten ? '<p>Zutaten: ' + product.zutaten + '</p>' : '') +
                  ziehText +
                '</div>' +
              '</div>' +
              '<div class="footer small">' +
                (product.bio ? '<div class="bio_icon_footer">' + bioHtml + '</div>' : '') +
                '<h3>Teeblatt</h3>' +
                '<p>Milchgasse 2, 5000 Aarau, www.teeblatt.ch</p>' +
              '</div>' +
            '</div>'
          );
        }
      });

      // Arrange into pages of 10
      var labelsHtml = '';
      for (var page = 0; page < Math.ceil(allLabels.length / 10); page++) {
        var pageLabels = allLabels.slice(page * 10, (page + 1) * 10);
        labelsHtml += '<div class="etiketten_container">';

        labelsHtml += '<div class="container_5_items">';
        for (var i = 0; i < Math.min(5, pageLabels.length); i++) {
          labelsHtml += pageLabels[i];
        }
        labelsHtml += '</div>';

        if (pageLabels.length > 5) {
          labelsHtml += '<div class="container_5_items flip">';
          for (var j = 5; j < pageLabels.length; j++) {
            labelsHtml += pageLabels[j];
          }
          labelsHtml += '</div>';
        }

        labelsHtml += '</div>';
      }

      // Open print window
      var printWindow = window.open('', '_blank');
      printWindow.document.write(
        '<!DOCTYPE html>' +
        '<html lang="de">' +
        '<head>' +
        '<meta charset="UTF-8">' +
        '<title>Etiketten drucken</title>' +
        '<style>' +
          '@font-face {' +
            'font-family: "MaisonNeue-Demi";' +
            'src: url("https://cdn.shopify.com/s/files/1/0981/7899/0457/files/MaisonNeue-Demi.woff2?v=1771508939") format("woff2"),' +
                 'url("https://cdn.shopify.com/s/files/1/0981/7899/0457/files/MaisonNeue-Demi.woff?v=1771508939") format("woff");' +
            'font-style: normal; font-weight: 400;' +
          '}' +
          '@font-face {' +
            'font-family: "MaisonNeue-Light";' +
            'src: url("https://cdn.shopify.com/s/files/1/0981/7899/0457/files/MaisonNeue-Light.woff2?v=1771508254") format("woff2"),' +
                 'url("https://cdn.shopify.com/s/files/1/0981/7899/0457/files/MaisonNeue-Light.woff?v=1771508876") format("woff");' +
            'font-style: normal; font-weight: 400;' +
          '}' +
          '@font-face {' +
            'font-family: "Sofa-Sans-Hand";' +
            'src: url("https://cdn.shopify.com/s/files/1/0981/7899/0457/files/Sofa-Sans-Hand.woff2?v=1771508255") format("woff2"),' +
                 'url("https://cdn.shopify.com/s/files/1/0981/7899/0457/files/Sofa-Sans-Hand.woff?v=1771508815") format("woff");' +
            'font-style: normal; font-weight: 400;' +
          '}' +
          '*, *:before, *:after { box-sizing: border-box; margin: 0; padding: 0; }' +
          'html, body { width: 297mm; height: 210mm; margin: 0; padding: 0; }' +
          'body {' +
            'font-size: 8.5pt; line-height: 11pt;' +
            'font-family: "MaisonNeue-Light", Arial, sans-serif;' +
            'font-weight: normal; color: #000; background: #fff;' +
            'text-rendering: optimizeLegibility;' +
            '-webkit-font-smoothing: antialiased;' +
          '}' +
          'h1, h2, h3, h4 {' +
            'font-family: "Sofa-Sans-Hand", Georgia, serif;' +
            'font-style: normal; font-variant: normal; font-weight: normal; color: #000;' +
          '}' +
          'h1 {' +
            'width: 100%; margin-left: auto; margin-right: auto;' +
            'font-size: 22pt; line-height: 25pt; margin-bottom: 6mm;' +
          '}' +
          'h3 {' +
            'font-family: "MaisonNeue-Demi", Arial, sans-serif;' +
            'font-size: 10pt; line-height: 13pt; margin-bottom: 2mm;' +
          '}' +
          '.small { font-size: 6pt; line-height: 7.5pt; }' +
          'b, strong { font-family: "MaisonNeue-Demi", Arial, sans-serif; font-weight: 400; }' +
          '.etiketten_container {' +
            'position: relative; margin-left: 6mm;' +
            'width: calc(297mm - 6mm); height: 210mm;' +
            'font-size: 8.5pt; line-height: 11pt;' +
            'font-family: "MaisonNeue-Light", Arial, sans-serif;' +
            '-webkit-page-break-after: always; page-break-after: always; break-after: always;' +
          '}' +
          '.etiketten_container::after { clear: both; content: ""; display: table; }' +
          '.container_5_items { position: static; float: left; width: 100%; height: 105mm; }' +
          '.container_5_items.flip {' +
            'transform: scale(-1, -1); transform-origin: center center; margin-left: -6mm;' +
          '}' +
          '.etiketten_item { position: relative; float: left; width: 57mm; height: 105mm; }' +
          '.etiketten_item .content {' +
            'position: absolute; top: 0; left: 0;' +
            'width: 57mm; height: 80mm;' +
            'padding-top: 12mm; text-align: center; overflow: hidden;' +
          '}' +
          '.etiketten_item .content.without_icons { height: 93mm; }' +
          '.etiketten_item .content h1 { hyphens: manual; padding-left: 1mm; padding-right: 1mm; }' +
          '.etiketten_item .content p { margin-bottom: 4mm; hyphens: manual; padding-left: 1mm; padding-right: 1mm; }' +
          '.etiketten_item .bio_icon_footer {' +
            'width: 100%; text-align: center; margin-bottom: 2mm;' +
          '}' +
          '.etiketten_item .bio_icon_footer .icon_image {' +
            'width: 10mm; height: 10mm; display: inline-block;' +
          '}' +
          '.etiketten_item .footer {' +
            'position: absolute; bottom: 0; left: 0;' +
            'width: 57mm; height: auto; min-height: 12mm; text-align: center; padding-bottom: 2mm;' +
          '}' +
          '@media print {' +
            '@page { size: 297mm 210mm landscape; margin: 0; }' +
            'body { margin: 0; padding: 0; }' +
          '}' +
        '</style>' +
        '</head>' +
        '<body>' +
        labelsHtml +
        '</body></html>'
      );
      printWindow.document.close();

      // Wait for fonts to load, then print
      setTimeout(function() {
        printWindow.focus();
        printWindow.print();
      }, 800);

    } catch (error) {
      console.error('Error generating labels:', error);
      alert('Fehler beim Erstellen der Etiketten. Bitte versuchen Sie es erneut.');
    }
  }

})(); // End of IIFE